import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]



type Props = {
	explain: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    explain: null
  },
  setup(__props: any) {

const props = __props as {
	explain: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "UIExplain",
    innerHTML: props.explain
  }, null, 8, _hoisted_1))
}
}

})